/* HCB Spooky Sale — interactive bits (17–25 Oct 2026)
   Remove the include line in snippets/theme-globals.liquid to switch off. */
(function () {
  'use strict';
  if (window.__hcbSpooky) return;
  window.__hcbSpooky = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var touch = window.matchMedia('(hover: none)').matches;
  var rand = function (a, b) { return a + Math.random() * (b - a); };
  var pick = function (arr) { return arr[Math.floor(Math.random() * arr.length)]; };

  var SVG = {
    bat: function (c) { return '<svg viewBox="0 0 64 32" aria-hidden="true"><path fill="' + c + '" d="M32 10c-2-4-4-5-4-5l-1 4c-3-2-8-2-12 0C10 4 4 4 0 6c5 2 8 6 8 11 4-3 9-2 11 1 2-3 6-4 9-2 1 2 3 4 4 6 1-2 3-4 4-6 3-2 7-1 9 2 2-3 7-4 11-1 0-5 3-9 8-11-4-2-10-2-15 3-4-2-9-2-12 0l-1-4s-2 1-4 5z"/></svg>'; },
    ghost: function (c) { return '<svg viewBox="0 0 28 33" aria-hidden="true"><path fill="' + c + '" d="M0 14a14 14 0 0 1 28 0v18l-4.7-4-4.6 4-4.7-4-4.6 4-4.7-4L0 32z"/><ellipse cx="9" cy="13" rx="2.4" ry="3.2" fill="#2a1450"/><ellipse cx="19" cy="13" rx="2.4" ry="3.2" fill="#2a1450"/><ellipse cx="14" cy="21" rx="2" ry="2.6" fill="#2a1450"/></svg>'; },
    pumpkin: function () { return '<svg viewBox="0 0 32 26" aria-hidden="true"><path d="M15 3q2-3 5-2" stroke="#6f8f32" stroke-width="2.5" fill="none" stroke-linecap="round"/><ellipse cx="9" cy="15" rx="8" ry="10" fill="#ff9f5a"/><ellipse cx="23" cy="15" rx="8" ry="10" fill="#ff9f5a"/><ellipse cx="16" cy="15" rx="8" ry="11" fill="#ffb27a"/><path d="M10 13l3 3h-4zM22 13l1 3h-4zM10 19q6 4 12 0q-6 2-12 0z" fill="#6b3410"/></svg>'; },
    bear: function (c) { return '<svg viewBox="0 0 30 36" aria-hidden="true"><g fill="' + c + '"><circle cx="8" cy="5" r="4"/><circle cx="22" cy="5" r="4"/><circle cx="15" cy="10" r="8"/><ellipse cx="15" cy="24" rx="10" ry="11"/><circle cx="4" cy="20" r="3.5"/><circle cx="26" cy="20" r="3.5"/><circle cx="8" cy="33" r="3.5"/><circle cx="22" cy="33" r="3.5"/></g><ellipse cx="11" cy="8" rx="2" ry="3" fill="#fff" opacity=".45"/></svg>'; },
    spider: '<svg viewBox="0 0 40 34" aria-hidden="true"><g stroke="#14091f" stroke-width="2.2" fill="none" stroke-linecap="round"><path d="M15 14l-8-8-6 3M15 18l-10-2-5 5M15 22l-9 5-4 6M17 25l-5 7"/><path d="M25 14l8-8 6 3M25 18l10-2 5 5M25 22l9 5 4 6M23 25l5 7"/></g><circle cx="20" cy="11" r="5" fill="#14091f"/><ellipse cx="20" cy="22" rx="8" ry="9" fill="#14091f"/><circle cx="18" cy="10" r="1.3" fill="#f26d98"/><circle cx="22" cy="10" r="1.3" fill="#f26d98"/></svg>'
  };
  var GUMMY = ['#f26d98', '#8b4dff', '#ff9f5a', '#5fd3c4', '#ffd166', '#e0475b'];

  function el(tag, cls, html) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (html) n.innerHTML = html;
    return n;
  }

  function init() {
    var layer = el('div', 'spooky-layer');
    layer.setAttribute('aria-hidden', 'true');
    document.body.appendChild(layer);

    /* ---- 1. Gummy bear burst on every add to cart (works on mobile too) ---- */
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest(
        '.product-form__cart-submit, .product-item__quick-view, .product-item__quick-view--hoverless, [name="add"]'
      );
      if (!btn || reduce) return;
      var r = btn.getBoundingClientRect();
      burst(r.left + r.width / 2, r.top + r.height / 2);
    }, true);

    function burst(x, y) {
      for (var i = 0; i < 16; i++) {
        var b = el('div', 'spooky-gummy', SVG.bear(pick(GUMMY)));
        b.style.left = x + 'px';
        b.style.top = y + 'px';
        layer.appendChild(b);
        var ang = rand(-Math.PI * 0.95, -Math.PI * 0.05);
        var dist = rand(90, 220);
        var dx = Math.cos(ang) * dist, dy = Math.sin(ang) * dist;
        var anim = b.animate([
          { transform: 'translate(-50%,-50%) scale(.3) rotate(0deg)', opacity: 1 },
          { transform: 'translate(calc(-50% + ' + dx + 'px), calc(-50% + ' + dy + 'px)) scale(1) rotate(' + rand(-200, 200) + 'deg)', opacity: 1, offset: .55 },
          { transform: 'translate(calc(-50% + ' + dx * 1.2 + 'px), calc(-50% + ' + (dy + 160) + 'px)) scale(.9) rotate(' + rand(-360, 360) + 'deg)', opacity: 0 }
        ], { duration: rand(900, 1300), easing: 'cubic-bezier(.2,.7,.4,1)' });
        anim.onfinish = (function (n) { return function () { n.remove(); }; })(b);
      }
    }

    if (reduce) return; /* everything below is pure motion */

    /* ---- 2. Floaters: a handful of ghosts, bats and pumpkins wandering across the screen ---- */
    var kinds = [
      function () { return SVG.ghost(pick(['#cdb8ff', '#ffc1d6', '#b48cff'])); },
      function () { return SVG.bat(pick(['#8b4dff', '#2a1450', '#f26d98'])); },
      function () { return SVG.pumpkin(); }
    ];
    var count = touch ? 4 : 7;
    for (var i = 0; i < count; i++) spawnFloater(i, true);

    function spawnFloater(i, first) {
      var f = el('div', 'spooky-floater');
      var inner = el('div', 'spooky-floater__inner', kinds[i % kinds.length]());
      f.appendChild(inner);
      var size = rand(touch ? 26 : 34, touch ? 44 : 70);
      var dur = rand(22, 38);
      f.style.setProperty('--size', size + 'px');
      f.style.setProperty('--x0', rand(-5, 95) + 'vw');
      f.style.setProperty('--dx', rand(-35, 35) + 'vw');
      f.style.setProperty('--dur', dur + 's');
      f.style.setProperty('--sway', rand(2.5, 5) + 's');
      f.style.setProperty('--tilt', rand(8, 22) + 'deg');
      f.style.animationDelay = first ? (-rand(0, dur)) + 's' : '0s';
      f.style.opacity = rand(.45, .8);
      f.addEventListener('animationiteration', function () {
        f.style.setProperty('--x0', rand(-5, 95) + 'vw');
        f.style.setProperty('--dx', rand(-35, 35) + 'vw');
      });
      layer.appendChild(f);
    }

    /* ---- 3. Scroll spider: hangs on a thread on the right edge and follows your scroll ---- */
    var rail = el('div', 'spooky-scroll', '<span class="spooky-scroll__thread"></span><span class="spooky-scroll__spider">' + SVG.spider + '</span>');
    layer.appendChild(rail);
    var thread = rail.firstChild, spider = rail.lastChild, ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var max = document.documentElement.scrollHeight - window.innerHeight;
        var p = max > 0 ? Math.min(1, window.scrollY / max) : 0;
        var y = 20 + p * (window.innerHeight - 90);
        thread.style.height = y + 'px';
        spider.style.transform = 'translateY(' + y + 'px)';
        rail.classList.toggle('is-visible', max > 400);
        ticking = false;
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    onScroll();
    spider.addEventListener('click', function () {
      spider.classList.remove('is-wiggle'); void spider.offsetWidth; spider.classList.add('is-wiggle');
    });

    /* ---- 4. Peekaboo ghost: pops out from the side every so often. Catch it! ---- */
    var peek = el('button', 'spooky-peek', SVG.ghost('#efe6ff') + '<span class="spooky-peek__bubble">Boo!</span>');
    peek.type = 'button';
    peek.setAttribute('aria-label', 'Catch the ghost');
    document.body.appendChild(peek);
    var toast = el('div', 'spooky-toast');
    toast.setAttribute('role', 'status');
    document.body.appendChild(toast);
    var peekTimer;
    function schedulePeek(ms) {
      clearTimeout(peekTimer);
      peekTimer = setTimeout(function () {
        peek.classList.toggle('from-left', Math.random() < .5);
        peek.style.top = rand(25, 65) + 'vh';
        peek.classList.add('is-out');
        setTimeout(function () { peek.classList.remove('is-out'); schedulePeek(rand(18000, 30000)); }, 4200);
      }, ms);
    }
    schedulePeek(8000);
    var caught = 0;
    peek.addEventListener('click', function () {
      caught++;
      peek.classList.remove('is-out');
      peek.classList.add('is-caught');
      setTimeout(function () { peek.classList.remove('is-caught'); }, 700);
      var r = peek.getBoundingClientRect();
      burst(r.left + r.width / 2, r.top + r.height / 2);
      toast.textContent = caught === 1
        ? 'You caught a ghost! Up to 62% off until 25 Oct.'
        : 'Ghost #' + caught + ' caught. Ghostbuster status unlocked.';
      toast.classList.add('is-show');
      setTimeout(function () { toast.classList.remove('is-show'); }, 3200);
      schedulePeek(rand(15000, 25000));
    });

    /* ---- 5. A spider drops from the top of the screen now and then ---- */
    function dropSpider() {
      var d = el('div', 'spooky-drop', '<span class="spooky-drop__thread"></span>' + SVG.spider);
      d.style.left = rand(8, 88) + 'vw';
      layer.appendChild(d);
      setTimeout(function () { d.remove(); }, 7000);
      setTimeout(dropSpider, rand(25000, 40000));
    }
    setTimeout(dropSpider, 14000);

    /* ---- 6. Glowing eyes in the footer that follow your cursor ---- */
    var footer = document.querySelector('.footer');
    if (footer) {
      var eyes = [];
      for (var k = 0; k < (touch ? 2 : 4); k++) {
        var pair = el('div', 'spooky-eyes', '<span><i></i></span><span><i></i></span>');
        pair.style.left = rand(5, 90) + '%';
        pair.style.top = rand(20, 75) + '%';
        pair.style.setProperty('--blink-delay', rand(0, 6) + 's');
        pair.style.setProperty('--s', rand(.8, 1.4));
        footer.appendChild(pair);
        eyes.push(pair);
      }
      if (!touch) {
        document.addEventListener('mousemove', function (e) {
          eyes.forEach(function (p) {
            var r = p.getBoundingClientRect();
            var a = Math.atan2(e.clientY - (r.top + r.height / 2), e.clientX - (r.left + r.width / 2));
            p.style.setProperty('--px', (Math.cos(a) * 2.5).toFixed(2) + 'px');
            p.style.setProperty('--py', (Math.sin(a) * 2.5).toFixed(2) + 'px');
          });
        }, { passive: true });
      }
    }

    /* ---- 7. Desktop: a faint trail of sparkles behind the cursor ---- */
    if (!touch) {
      var last = 0;
      document.addEventListener('mousemove', function (e) {
        var now = Date.now();
        if (now - last < 70) return;
        last = now;
        var s = el('div', 'spooky-spark');
        s.style.left = e.clientX + 'px';
        s.style.top = e.clientY + 'px';
        s.style.background = pick(['#8b4dff', '#f26d98', '#cdb8ff']);
        layer.appendChild(s);
        setTimeout(function () { s.remove(); }, 700);
      }, { passive: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();